import { ProductAttributeInterface } from '../../../../Interface/ProductAttribute';
import ClearanceDescription from '../../ClearanceDescription/ClearanceDescription';
import { getFlavourDiscount } from '../../../Helper/flavourDiscount';
import { formatCurrencyEur } from '../../../Helper/formatter';
import styles from './ProductAttributeName.module.scss?module';
import clsx from 'clsx';

export default function ProductAttributeName({
  product_attribute,
  isUserLoggedIn,
  showDiscountDetails = false,
}: {
  product_attribute: ProductAttributeInterface;
  isUserLoggedIn: boolean;
  /**
   * Pro Flavour den kombinierten Rabatt (Prozentwert) und – nur eingeloggt – den
   * reduzierten Preis anzeigen. Wird von der PID-Ebene gesteuert
   * (getProductSizeDiscountDisplay) und ist gesetzt, wenn eine Promotion vorliegt
   * oder sich die Clearance-Rabatte zwischen den Flavours unterscheiden (P-4877).
   * Bei einheitlichem Clearance-Rabatt steht unter dem Flavour nur der Grund.
   */
  showDiscountDetails?: boolean;
}) {
  const discount = getFlavourDiscount(product_attribute);

  // Unter dem Flavour steht der Clearance-Grund (z.B. "Short Expiry"). Bei
  // showDiscountDetails kommen der jeweilige Prozentwert und – nur für eingeloggte
  // Nutzer – der reduzierte Preis dazu (P-4877 / P-4751).
  const percentText =
    showDiscountDetails && discount.percent > 0
      ? `${discount.percentLabel}% Off`
      : null;
  const priceText =
    showDiscountDetails && isUserLoggedIn && discount.combinedPrice != null
      ? formatCurrencyEur(discount.combinedPrice)
      : null;
  const parts = [discount.reason, percentText, priceText].filter(Boolean);
  const hasClearanceInfo = discount.isClearance && parts.length > 0;

  return (
    <div className="d-flex align-items-center">
      {isUserLoggedIn ? (
        <div className="d-flex align-items-center justify-content-center d-md-none me-2">
          <span
            className={clsx(
              styles.dot,
              product_attribute.has_stock ? 'bg-success' : 'bg-danger'
            )}
          />
        </div>
      ) : null}
      <div className="fw-bold">
        <p className="m-0">{product_attribute.name}</p>

        {hasClearanceInfo ? (
          <ClearanceDescription>{parts.join(' / ')}</ClearanceDescription>
        ) : null}
      </div>
    </div>
  );
}
